import * as React from "react";
import { jsx } from "react/jsx-runtime";
const PresenceContext = React.createContext(null),
  ResetPresence = props => /* @__PURE__ */jsx(PresenceContext.Provider, {
    value: null,
    children: props.children
  });
export { PresenceContext, ResetPresence };
//# sourceMappingURL=PresenceContext.mjs.map
